import { render } from "./CommunityTalkUserReviewerAttributeAnswer.vue?vue&type=template&id=3505523f&ts=true"
import script from "./CommunityTalkUserReviewerAttributeAnswer.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunityTalkUserReviewerAttributeAnswer.vue?vue&type=script&lang=ts&setup=true"

import "./CommunityTalkUserReviewerAttributeAnswer.vue?vue&type=style&index=0&id=3505523f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/CommunityTalkUserReviewerAttributeAnswer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3505523f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3505523f', __exports__)) {
    api.reload('3505523f', __exports__)
  }
  
  module.hot.accept("./CommunityTalkUserReviewerAttributeAnswer.vue?vue&type=template&id=3505523f&ts=true", () => {
    api.rerender('3505523f', render)
  })

}


export default __exports__